import { DebugManager } from '../utility/DebugManager';

/**
 * Global DebugManager instance for the error handling system.
 *
 * Captures all ErrorHandler decisions (toast routing, LogMessage submission,
 * dedup, translation, runtime errors, unhandled rejections) regardless of
 * which feature triggered the error.
 *
 * Scope-specific debug managers (e.g. orderFlowDebug) override this for
 * errors with a registered scope. This global instance is the fallback
 * for all non-scoped errors.
 *
 * Enabled via ?debug in the URL, sessionStorage, or localStorage.
 */
export const errorHandlingDebug = new DebugManager({
  namespace: 'ErrorHandling'
});
